<mat-card-header class="layout-row gap-5percent">
  <fa-icon class="main-icon" icon="user" size="3x"></fa-icon>
  <mat-card-title-group>
    <div class="mat-typography">
      <mat-card-title>
        <h2>
          {{ clientData.displayName }}
          <span [className]="clientData.status.code | statusLookup">
            <fa-icon
              matTooltip="{{ clientData.status.value }}"
              matTooltipPosition="right"
              icon="circle"
              size="lg"
            ></fa-icon>
          </span>
        </h2>
      </mat-card-title>
      <mat-card-subtitle>
        <p>
          {{ 'labels.inputs.Account No' | translate }}: {{ clientData.accountNo }}
          {{ clientData.externalId ? '| External ID: ' + clientData.externalId : '' }}
        </p>
      </mat-card-subtitle>
    </div>
  </mat-card-title-group>
</mat-card-header>

<mat-card-content>
  <mat-tab-group>
    <mat-tab label="Details">
      <div class="layout-row-wrap">
        @if (clientData.firstName) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.First Name' | translate }}
          </div>
        }

        @if (clientData.firstName) {
          <div class="flex-50">
            {{ clientData.firstName }}
          </div>
        }

        @if (clientData.middleName) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Middle Name' | translate }}
          </div>
        }

        @if (clientData.middleName) {
          <div class="flex-50">
            {{ clientData.middleName }}
          </div>
        }

        @if (clientData.lastName) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Last Name' | translate }}
          </div>
        }

        @if (clientData.lastName) {
          <div class="flex-50">
            {{ clientData.lastName }}
          </div>
        }

        @if (clientData.dateOfBirth) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Date of Birth' | translate }}
          </div>
        }

        @if (clientData.dateOfBirth) {
          <div class="flex-50">
            {{ clientData.dateOfBirth | dateFormat }}
          </div>
        }

        @if (clientData.mobileNo) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Mobile Number' | translate }}
          </div>
        }

        @if (clientData.mobileNo) {
          <div class="flex-50">
            {{ clientData.mobileNo }}
          </div>
        }

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Activation Date' | translate }}
        </div>

        <div class="flex-50">
          {{ clientData.activationDate | dateFormat }}
        </div>

        @if (clientData.officeName) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Associated Office' | translate }}
          </div>
        }

        @if (clientData.officeName) {
          <div class="flex-50">
            {{ clientData.officeName }}
          </div>
        }

        @if (clientData.staffName) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Associated Staff' | translate }}
          </div>
        }

        @if (clientData.staffName) {
          <div class="flex-50">
            {{ clientData.staffName }}
          </div>
        }
      </div>
    </mat-tab>

    @if (clientAccountsData && clientAccountsData.loanAccounts) {
      <mat-tab label="Loan Accounts">
        <LOSx-loan-account-table [loanAccountData]="clientAccountsData.loanAccounts"></LOSx-loan-account-table>
      </mat-tab>
    }

    @if (clientAccountsData && clientAccountsData.savingsAccounts) {
      <mat-tab label="Savings Accounts">
        <LOSx-savings-account-table
          [savingsAccountData]="clientAccountsData.savingsAccounts"
        ></LOSx-savings-account-table>
      </mat-tab>
    }

    @if (clientAccountsData && clientAccountsData.shareAccounts) {
      <mat-tab label="Share Accounts">
        <LOSx-share-account-table [shareAccountData]="clientAccountsData.shareAccounts"></LOSx-share-account-table>
      </mat-tab>
    }

    @if (clientData.groups && clientData.groups.length !== 0) {
      <mat-tab label="Group Members">
        <LOSx-member-groups [memberGroupData]="clientData.groups"></LOSx-member-groups>
      </mat-tab>
    }
  </mat-tab-group>
</mat-card-content>
